import { render, staticRenderFns } from "./exchangeRate.vue?vue&type=template&id=0a784990&"
import script from "./exchangeRate.vue?vue&type=script&lang=js&"
export * from "./exchangeRate.vue?vue&type=script&lang=js&"
import style0 from "./exchangeRate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports